import React from "react";
import '../Splitman/Splitman.css'

export default function Splitman() {
    return (
        <div className="splitman">
            <h1>Hello World!</h1>
        </div>
    )
}